import React from 'react';
import {useStyles} from '@ace-de/ui-components';
import styles from './PanelLogo.module.scss';

const PanelLogo = React.forwardRef((props, ref) => {
    const {cx} = useStyles(props, styles);

    return (
        <div ref={ref} className={cx('ace-c-panel-logo')} />
    );
});

export default PanelLogo;
